import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    setCalculationValue: (field: string, value: string) => void;
    roomLength?: string;
    roomWidth?: string;
    tileWidth?: string;
    tileLength?: string;
    packageArea?: string;
};

const Calculation = ({
    setCalculationValue,
    roomLength,
    roomWidth,
    tileWidth,
    tileLength,
    packageArea
}: Props) => {
    const { t } = useGranite();

    return (
        <div>
            <Row>
                <Col
                    xs={12}
                    md={6}
                    className={"mt-4"}
                >
                    <Row>
                        <Col xs={12}>
                            <h3 className="d-sm-block">
                                {t(
                                    "calculator.tileCalculator.roomMeasurements"
                                )}
                            </h3>
                        </Col>
                        <CalculationField
                            name={"roomLength"}
                            dimension={"length"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            value={roomLength}
                            sm={6}
                            md={4}
                        />
                        <CalculationField
                            name={"roomWidth"}
                            dimension={"width"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            value={roomWidth}
                            sm={6}
                            md={4}
                        />
                    </Row>
                </Col>
                <Col
                    xs={12}
                    md={6}
                    className={"mt-4"}
                >
                    <Row>
                        <Col xs={12}>
                            <h3 className="d-sm-block">
                                {t(
                                    "calculator.tileCalculator.tileMeasurements"
                                )}
                            </h3>
                        </Col>
                        <CalculationField
                            name={"tileLength"}
                            dimension={"length"}
                            unit={"cm"}
                            setCalculationValue={setCalculationValue}
                            value={tileLength}
                            sm={6}
                            md={4}
                        />
                        <CalculationField
                            name={"tileWidth"}
                            dimension={"width"}
                            unit={"cm"}
                            setCalculationValue={setCalculationValue}
                            value={tileWidth}
                            sm={6}
                            md={4}
                        />
                    </Row>
                </Col>
            </Row>
            <Row className={"mt-4"}>
                <Col xs={12}>
                    <h3 className="d-sm-block">
                        {t("calculator.tileCalculator.package")}
                    </h3>
                </Col>
                <CalculationField
                    name={"packageArea"}
                    dimension={"area"}
                    unit={"m"}
                    sup={2}
                    setCalculationValue={setCalculationValue}
                    value={packageArea}
                    sm={6}
                    md={4}
                />
            </Row>
        </div>
    );
};

export default Calculation;
